import { Alert, AlertColor, Stack } from '@mui/material';
import UtilityDrawerFooter from '../utility-drawer/utility-drawer-footer/utility-drawer-footer.component';

const DrawerButtonsWrapper = ({
  children,
  disclaimer = null,
  disclaimerSeverity = 'info' as AlertColor,
}) => {
  return (
    <UtilityDrawerFooter>
      {disclaimer && (
        <Alert severity={disclaimerSeverity} sx={{ marginBottom: 1 }}>
          {disclaimer}
        </Alert>
      )}
      <Stack spacing={1}>{children}</Stack>
    </UtilityDrawerFooter>
  );
};

export default DrawerButtonsWrapper;
